import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.125 16.3179L12.797 11.9898C13.6664 10.8293 14.187 9.39259 14.187 7.83068C14.187 3.9895 11.0731 0.87561 7.23193 0.87561C3.39074 0.87561 0.276855 3.9895 0.276855 7.83068C0.276855 11.6719 3.39074 14.7858 7.23193 14.7858C8.79384 14.7858 10.2306 14.2641 11.3911 13.3957L15.7191 17.7238L17.125 16.3179ZM2.26402 7.82969C2.26402 5.09038 4.49262 2.86178 7.23193 2.86178C9.97123 2.86178 12.1998 5.09038 12.1998 7.82969C12.1998 10.569 9.97123 12.7976 7.23193 12.7976C4.49262 12.7976 2.26402 10.569 2.26402 7.82969Z",
		fill: "currentColor"
	})
});
export default SvgSearch;
